import { api, clearToken, getToken, setToken } from "./api";

export async function loginAdmin(email, password) {
  const data = await api("/api/admin/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
  setToken(data.token);
  localStorage.setItem("fpb_admin", JSON.stringify(data.admin));
  return data.admin;
}

export function logoutAdmin() {
  clearToken();
  localStorage.removeItem("fpb_admin");
}

export function isLoggedIn() {
  return Boolean(getToken());
}

export function getAdmin() {
  try {
    return JSON.parse(localStorage.getItem("fpb_admin") || "null");
  } catch {
    return null;
  }
}


export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  editor: "Editor",
  publisher: "Publisher",
  news_event_admin: "News & Events Admin",
};

export function getAdminRole() {
  return getAdmin()?.role || "";
}

export function isNewsEventAdmin() {
  return getAdminRole() === "news_event_admin";
}

export function canAccessAdminPath(pathname) {
  const role = getAdminRole();
  if (role === "news_event_admin") {
    return ["/adxm/dashboard", "/adxm/news", "/adxm/events", "/adxm/manage-events"].some((path) => pathname.startsWith(path));
  }
  return true;
}
